import { render, staticRenderFns } from "./Temperature.vue?vue&type=template&id=507ff9dd&scoped=true&"
import script from "./Temperature.vue?vue&type=script&lang=ts&"
export * from "./Temperature.vue?vue&type=script&lang=ts&"
import style0 from "./Temperature.vue?vue&type=style&index=0&id=507ff9dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507ff9dd",
  null
  
)

export default component.exports